import createSvgIcon from '../Utils/CreateSvgIcon';

export const ArrowTop = createSvgIcon(
  <path
    clipRule="evenodd"
    d="M10.9996 6.82978L11.0005 21.0005L13.0005 21.0004L12.9996 6.82805L19.7787 13.6071L21.1929 12.1929L12.0005 3.00049L2.80713 12.1938L4.22134 13.6081L10.9996 6.82978Z"
    fillRule="evenodd"
  />,
  'ArrowTop',
);
